import BaseService from '@/ecm/common/BaseService.js';
import Utils from '@/ecm/common/Utils.js';

class FlowService {
  baseUrl = 'flow';

  getFlowById = (flowId) => BaseService.get({ url: `${this.baseUrl}/${flowId}` });
  getGrid = () => Utils.grid.getParameters(`${this.baseUrl}/get-grid`);
  getAvailableContentTypes = (flowId) => BaseService.get({ url: `${this.baseUrl}/get-available-content-types/${flowId}` });
  getStates = (flowId) => BaseService.get({ url: `${this.baseUrl}/get-states/${flowId}` });
  delete = (id) => BaseService.post({ url: `${this.baseUrl}/delete/${id}` });
  save = (flow) => BaseService.post({ url: `${this.baseUrl}/save`, data: flow });
  saveStates = (states) => BaseService.post({ url: `${this.baseUrl}/save-states`, data: states });
}

export default new FlowService();
